"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelConfirm = exports.Confirm = exports.Save = exports.OkCancel = exports.Ok = exports.YesNoCancel = exports.YesNo = void 0;

var actions = _interopRequireWildcard(require("../store/actions"));

// import Store from '@eig-builder/core-utils/store'
var YesNo = function YesNo(props) {
  return function (dispatch) {
    dispatch(actions.YesNo(props));
  };
};

exports.YesNo = YesNo;

var YesNoCancel = function YesNoCancel(props) {
  return function (dispatch) {
    dispatch(actions.YesNoCancel(props));
  };
};

exports.YesNoCancel = YesNoCancel;

var Ok = function Ok(props) {
  return function (dispatch) {
    dispatch(actions.Ok(props));
  };
};

exports.Ok = Ok;

var OkCancel = function OkCancel(props) {
  return function (dispatch) {
    dispatch(actions.OkCancel(props));
  };
};

exports.OkCancel = OkCancel;

var Save = function Save(props) {
  return function (dispatch) {
    dispatch(actions.Save(props));
  };
};

exports.Save = Save;

var Confirm = function Confirm(props) {
  return function (dispatch) {
    dispatch(actions.Confirm(props));
  };
};

exports.Confirm = Confirm;

var CancelConfirm = function CancelConfirm(props) {
  return function (dispatch) {
    dispatch(actions.CancelConfirm(props));
  };
};

exports.CancelConfirm = CancelConfirm;